import React from 'react'
import { useSelector} from 'react-redux'
import {useParams} from "react-router-dom";
import RenderedImageMap from "./rendered_image_map";

const ImageMapRenderer = ({imageMapIdentifier, imageMapId, AddonRenderer}) => {
  const imageMaps = useSelector((state) => state.imageMaps)
  const {imageMapIdentifierParam, imageMapIdParam} = useParams();

  const imageMap = imageMaps.find((img) => img.identifier == imageMapIdentifier)
    || imageMaps.find((img) => img.id == imageMapId)
    || imageMaps.find((img) => img.identifier == imageMapIdentifierParam)
    || imageMaps.find((img) => img.id == imageMapIdParam)

  return <RenderedImageMap imageMapId={imageMap?.id} AddonRenderer={AddonRenderer}/>
}

export default ImageMapRenderer